import * as React from 'react';
import ThirdPartyIntegrationAuthorization from './ThirdPartyIntegrationAuthorization';
import { jobAdder } from '../../../core/constants';

const JobAdderAuthorization = () => {
	return <ThirdPartyIntegrationAuthorization integrationName={jobAdder} />;
};

export default JobAdderAuthorization;
